import { MutationTree } from 'vuex'
import { ChargingStationDeclarationState } from './types'
import { idGenerator } from '@/services'

export const mutations: MutationTree<ChargingStationDeclarationState> = {
  RESET(state) {
    state.requestId = idGenerator.getNewWebReference()
  }
}
